export function formatDate(dateString, format = 'long') {
  if (!dateString) return 'N/A';

  let date;
  if (format === 'iso' && typeof dateString === 'string' && dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
    // Parse YYYY-MM-DD as local date
    const [year, month, day] = dateString.split('-').map(Number);
    date = new Date(year, month - 1, day); // month is 0-based
  } else {
    // Parse datetime strings normally, letting JavaScript handle timezone conversion
    date = new Date(dateString);
  }

  if (isNaN(date.getTime())) return 'N/A'; // Handle invalid dates

  // YYYY-MM-DD (for follow_up_date)
  if (format === 'iso') {
    return date.toLocaleDateString('en-CA'); // Outputs 2025-05-29
  }

  // mm/dd/yy hh:mm AM/PM (e.g., 05/29/25 10:50 PM)
  if (format === 'short') {
    return date
      .toLocaleDateString('en-US', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      })
      .replace(',', '');
  }

  // MMM dd, yy, hh:mm AM/PM (e.g., May 29, 25, 10:50 PM)
  return date.toLocaleString('en-US', {
    year: '2-digit',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Formats call transcription text into an array of sentences for better readability
 * Splits on sentence-ending punctuation (.!?) followed by whitespace
 * @param {string} text - Raw transcription text
 * @returns {string[]} Array of sentences with punctuation preserved
 */
export function formatTranscriptionText(text) {
  if (!text || typeof text !== 'string') return [];

  // Split on sentence-ending punctuation (.!?) followed by whitespace
  // This regex captures the punctuation with the sentence
  const parts = text.split(/([.!?]+\s+)/);

  const sentences = [];

  // Combine sentence text with its punctuation
  for (let i = 0; i < parts.length; i += 2) {
    const sentence = parts[i];
    const punctuation = parts[i + 1] || '';
    const combined = (sentence + punctuation).trim();

    if (combined) {
      sentences.push(combined);
    }
  }

  return sentences;
}